import React, { useContext, useState } from 'react';
import { useApi } from '../../ApiContext';
import { UserContext } from '../../UserContext';
import { useNavigate } from 'react-router-dom';
import AppointmentConfirmation, { appointmentConfirmationViewModel } from './AppointmentConfirmation';
import { ApiErrorAlert, ApiError } from '../../components/ApiErrorAlert';

const ConfirmAppointmentScreen: React.FC = () => {
  const userContext = useContext(UserContext);
  const api = useApi();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState<ApiError | null>(null);

  if (!userContext) return null;

  const { userData } = userContext;
  const viewModel = appointmentConfirmationViewModel(userData);

  const handleNext = async () => {
    const { provider_id, timeSlot } = userData;
    if (!provider_id || !timeSlot) {
      // This is an invalid state, route back to the beginning.
      navigate('/');
      return;
    }

    setIsLoading(true);

    const { data, error } = await api.client.confirmAppointment({
      customer_id: userData.customer_id,
      provider_id: provider_id,
      service_ids: userData.service_ids,
      datetime: timeSlot,
    });

    setIsLoading(false);

    if (error) {
      setApiError(error);
      return;
    }

    if (data && data.isReserved) {
      navigate('/appointment-booked');
    } else {
      // The API is built to return an error for all failures so this error path is highly unlikely.
      alert(`We encountered a problem when trying to confirm your appointment.`);
    }

    setIsLoading(false);
  };

  return (
    <>
      <AppointmentConfirmation viewModel={viewModel} handleNext={handleNext} isLoading={isLoading} />
      <ApiErrorAlert screenName="appointment confirmation screen" apiError={apiError} clearError={setApiError} />
    </>
  );
};

export default ConfirmAppointmentScreen;
